import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { IContext } from '@context/models/context';
import { ITable } from '@common/models/table';
import { ArrearsTransactionDrillDownParamsModel } from '../models/arrears-transaction-drill-down-params.model';
import { DashboardItem } from '@dashboards/models/dashboard-item';

@Injectable()
export class ArrearsTransactionTableHttpService {

  constructor(private readonly http: HttpClient,
    private readonly urlBuilderService: UrlBuilderService) { }

  getTable(context: IContext,
    drillDownModel: ArrearsTransactionDrillDownParamsModel,
    dashboardItem: DashboardItem): Observable<ITable> {

    const url = this.urlBuilderService.getUrl(`debtanalysis/${dashboardItem.id}/contextquery`);

    const requestModel = {
      context: context,
      drillDownParams: drillDownModel
    };

    return this.http
      .post<ITable>(url, requestModel)
      .pipe(map(table => table || undefined));
  }
}
